import { Box, Typography, Card, IconButton } from "@mui/joy";
import { Minus, Plus } from "lucide-react";
import { measurementGroups, getMeasurementIcon } from "./types";

export function MobileView({ measurementData, handleMeasurementUpdate }: any) {
    const renderMobileMeasurementItem = (item: any, isLast: boolean) => (
        <Box
            key={item.name}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                borderBottom: isLast ? "none" : "1px solid",
                borderColor: "divider",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0, pr: 1 }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "sm",
                        bgcolor: "background.level1",
                        color: "text.tertiary",
                        flexShrink: 0,
                    }}
                >
                    {getMeasurementIcon(item.name)}
                </Box>
                <Typography level="body-sm" sx={{ fontWeight: "md" }} noWrap>
                    {item.name}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    bgcolor: "background.level1",
                    borderRadius: "32px",
                    p: 0.5,
                }}
            >
                <IconButton
                    variant="plain"
                    color="neutral"
                    size="sm"
                    onClick={() => handleMeasurementUpdate("remove", item)}
                    disabled={!item.actual || item.actual === 0}
                    sx={{ borderRadius: "50%", "--IconButton-size": "28px" }}
                >
                    <Minus size={14} />
                </IconButton>
                <Typography level="title-sm" sx={{ minWidth: "24px", textAlign: "center", fontWeight: "lg" }}>
                    {item.actual || 0}
                </Typography>
                <IconButton
                    variant="plain"
                    color="neutral"
                    size="sm"
                    onClick={() => handleMeasurementUpdate("add", item)}
                    sx={{ borderRadius: "50%", "--IconButton-size": "28px", bgcolor: "background.surface" }}
                >
                    <Plus size={14} />
                </IconButton>
            </Box>
        </Box>
    );

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {Object.entries(measurementGroups).map(([groupName, groupItems]) => {
                const itemsInGroup = measurementData.filter((item: any) => groupItems.includes(item.name));
                if (itemsInGroup.length === 0) return null;

                return (
                    <Card key={groupName} variant="outlined" sx={{ p: 0, overflow: "hidden", gap: 0 }}>
                        <Box
                            sx={{
                                py: 1,
                                px: 2,
                                bgcolor: "background.level1",
                                borderBottom: "1px solid",
                                borderColor: "divider",
                            }}
                        >
                            <Typography level="title-sm" sx={{ fontWeight: "lg" }}>
                                {groupName}
                            </Typography>
                        </Box>
                        <Box sx={{ px: 2 }}>
                            {itemsInGroup.map((item: any, index: number) =>
                                renderMobileMeasurementItem(item, index === itemsInGroup.length - 1),
                            )}
                        </Box>
                    </Card>
                );
            })}
        </Box>
    );
}
